// extracted by mini-css-extract-plugin
export default {"ImageHeader":"styles_ImageHeader__r1T+U"};